import React from 'react';

const PhoneSupport = () => {
  return (
    <div className="text-center">
      <h3 className="text-2xl font-bold mb-6 flex items-center justify-center gap-3">
        📞 Telepon Support
      </h3>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-blue-600 text-white p-6 rounded-2xl">
          <div className="text-4xl mb-3">📞</div>
          <h4 className="text-lg font-bold mb-2">Customer Care</h4>
          <div className="text-xl font-bold mb-2">1500-888</div>
          <p className="text-sm opacity-90">24 jam setiap hari</p>
        </div>
        <div className="bg-purple-600 text-white p-6 rounded-2xl">
          <div className="text-4xl mb-3">🔧</div>
          <h4 className="text-lg font-bold mb-2">Technical Support</h4>
          <div className="text-xl font-bold mb-2">1500-999</div>
          <p className="text-sm opacity-90">24 jam setiap hari</p>
        </div>
      </div>
    </div>
  );
};

export default PhoneSupport;